"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _content = _interopRequireDefault(require("./common/content"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
/**
 * Local Imports
 */

/**
 * MultiLogoSection Component.
 * @module MultiLogoSection
 *
 * @param {Object} props React props,
 * @param {String} props._name Tracking name of the component
 * @param {Object} props.items Array of Objects
 * @param {String} props.columnType Layout Identifier
 * @returns {React.ReactElement} MultiLogoSection Component
 * @public
 */

function MultiLogoSection({
  _name,
  items,
  columnType,
  verticalMargin,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "multi-logo-section",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(_content.default, (0, _extends2.default)({
    items: items,
    columnType: columnType
  }, rest)));
}
var _default = exports.default = MultiLogoSection;
MultiLogoSection.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.array,
  columnType: _propTypes.default.oneOf(['max-6', 'max-5']),
  ..._patternLibraryUtils.marginProps
};